import React from 'react';
import UserForm from '../components/UserForm';

export default function UsersPage({ user }){
  return (
    <div>
      {user && <UserForm user={user} />}
    </div>
  );
}
